import { createSlice } from "@reduxjs/toolkit";
import {
  postBookingRental,
  getBookingRental,
  deleteBookingRental,
  editBookingRental,
  sendBookingDocument,
  // downloadDocument,
  editStatusBookingRent,
  addBookingRentalAgreement,
  getBookingRentalAgreement,
  addDocumentConfirmToDatabase,
  getBookingRentalConfirm,
  addBookingRentalRelates,
  getBookingRentalRelates,
  deleteDocumentAgreementRent,
  deleteDocumentRelatesRent,
  editExtendStayRent,
  editDocumentConfirmToDatabase,
  editRemarkCancelToBooking,
  sendEmailLawyerForRental,
} from "API/SaleOrRentAPI";

// Sale
import {
  addSales,
  addSalesAgreement,
  addSalesRelates,
  getSales,
  getSalesAgreement,
  getSalesRelates,
  editSales,
  getRemarkSales,
  addRemarkSales,
  sendEmailSale,
  addDocConfirmSale,
  getDocConfirmSales,
  addPaymentTerm,
  getPaymentTerm,
  editPaymentTerm,
  deletePaymentTerm,
  sendEmailLawyerForSelling,
  deleteAgreementSale,
  deleteRelateSale,
  deleteSellingDraft,
} from "API/SaleOrRentAPI";

const initialState = {
  AddBookingRent: [],
  BookingRent: [],
  DeleteBookingRent: [],
  EditBookingRent: [],
  SendMail: [],
  Document: [],
  DocumentConfirm: [],
  DocumentAgreement: [],
  DocumentRelates: [],
  ResultsDocumentAgreement: [],
  DeleteDocumentAgreement: [],
  ResultsDocumentRelates: [],
  DeleteDocumentRelates: [],
  StatusBookingRent: [],
  ExtendStay: [],
  EditDocumentConfirm: [],
  Cancel: [],
  LawyerForRental: [],

  // Sale
  AddSale: [],
  AddSaleAgreement: [],
  AddSaleRelates: [],
  Sale: [],
  SaleDraft: [],
  SaleAgreement: [],
  SaleRelates: [],
  EditSale: [],
  RemarkSale: [],
  AddRemarkSale: [],
  SendMailSale: [],
  DocumentConfirmSale: [],
  AddPaymentTerm: [],
  PaymentTerm: [],
  EditPaymentTerm: [],
  DeletePaymentTerm: [],
  LawyerForSelling: [],
  DeleteAgreementSale: [],
  DeleteRelateSale: [],
  loadingBooking: false,
};

export const BookingSlice = createSlice({
  name: "UserState",
  initialState,
  reducers: {
    updateAddBookingRent: (state, action) => {
      state.AddBookingRent = action.payload;
    },
    updateGetBookingRent: (state, action) => {
      state.BookingRent = action.payload;
    },
    updateDeleteBookingRent: (state, action) => {
      state.DeleteBookingRent = action.payload;
    },
    updateEditBookingRent: (state, action) => {
      state.EditBookingRent = action.payload;
    },
    updateSendBookingDoc: (state, action) => {
      state.SendMail = action.payload;
    },
    updateDocument: (state, action) => {
      state.Document = action.payload;
    },
    updateStatusBookingRent: (state, action) => {
      state.StatusBookingRent = action.payload;
    },
    updateDocumentAgreement: (state, action) => {
      state.DocumentAgreement = action.payload;
    },
    updateResultsDocumentAgreement: (state, action) => {
      state.ResultsDocumentAgreement = action.payload;
    },
    updateGetDocumentConfirm: (state, action) => {
      state.DocumentConfirm = action.payload;
    },
    updateAddDocumentRelates: (state, action) => {
      state.DocumentRelates = action.payload;
    },
    updateGetDocumentRelates: (state, action) => {
      state.ResultsDocumentRelates = action.payload;
    },
    updateDeleteDocumentAgreement: (state, action) => {
      state.DeleteDocumentAgreement = action.payload;
    },
    updateDeleteDocumentRelates: (state, action) => {
      state.DeleteDocumentRelates = action.payload;
    },
    updateEditExtendStay: (state, action) => {
      state.ExtendStay = action.payload;
    },
    updateEditDocumentConfirm: (state, action) => {
      state.EditDocumentConfirm = action.payload;
    },
    updateEditRemarkCancelToBooking: (state, action) => {
      state.Cancel = action.payload;
    },
    setLoadingBooking: (state, action) => {
      state.loadingBooking = action.payload;
    },
    updateLawyerForRental: (state, action) => {
      state.LawyerForRental = action.payload;
    },

    // Sale
    updateAddSale: (state, action) => {
      state.AddSale = action.payload;
    },
    updateAddSaleAgreement: (state, action) => {
      state.AddSaleAgreement = action.payload;
    },
    updateAddSaleRelates: (state, action) => {
      state.AddSaleRelates = action.payload;
    },
    updateSale: (state, action) => {
      state.Sale = action.payload;
    },
    updateSaleAgreement: (state, action) => {
      state.SaleAgreement = action.payload;
    },
    updateSaleRelates: (state, action) => {
      state.SaleRelates = action.payload;
    },
    updateEditSale: (state, action) => {
      state.EditSale = action.payload;
    },
    updateRemarkSale: (state, action) => {
      state.RemarkSale = action.payload;
    },
    updateAddRemarkSale: (state, action) => {
      state.AddRemarkSale = action.payload;
    },
    updateSendMailSale: (state, action) => {
      state.SendMailSale = action.payload;
    },
    updateGetDocumentConfirmSale: (state, action) => {
      state.DocumentConfirmSale = action.payload;
    },
    updateAddPaymentTerm: (state, action) => {
      state.AddPaymentTerm = action.payload;
    },
    updateGetPaymentTerm: (state, action) => {
      state.PaymentTerm = action.payload;
    },
    updateEditPaymentTerm: (state, action) => {
      state.EditPaymentTerm = action.payload;
    },
    updateDeletePaymentTerm: (state, action) => {
      state.DeletePaymentTerm = action.payload;
    },
    updateLawyerForSelling: (state, action) => {
      state.LawyerForSelling = action.payload;
    },
    updateDeleteAgreementSale: (state, action) => {
      state.DeleteAgreementSale = action.payload;
    },
    updateDeleteRelateSale: (state, action) => {
      state.DeleteRelateSale = action.payload;
    },
    updateDeleteSellingDraft: (state, action) => {
      state.SaleDraft = action.payload;
    },
  },
});

export const { setLoadingBooking } = BookingSlice.actions;
export const { updateAddBookingRent } = BookingSlice.actions;
export const AddBookingRentdetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingBooking(true));
    const data = await postBookingRental(value);
    dispatch(updateAddBookingRent(data));
    dispatch(setLoadingBooking(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingBooking(false));
  }
};

export const { updateGetBookingRent } = BookingSlice.actions;
export const getBookingRentdetail = (value) => async (dispatch) => {
  await getBookingRental(value).then(async (data) => {
    await dispatch(updateGetBookingRent(data));
  });
};

export const { updateDeleteBookingRent } = BookingSlice.actions;
export const deleteBookingRentdetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingBooking(true));
    const data = await deleteBookingRental(value);
    dispatch(updateDeleteBookingRent(data));
    dispatch(setLoadingBooking(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingBooking(false));
  }
};

export const { updateEditBookingRent } = BookingSlice.actions;
export const editBookingRentDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingBooking(true));
    const data = await editBookingRental(value);
    dispatch(updateEditBookingRent(data));
    dispatch(setLoadingBooking(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingBooking(false));
  }
};

export const { updateSendBookingDoc } = BookingSlice.actions;
export const sendBookingDocDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingBooking(true));
    const data = await sendBookingDocument(value);
    dispatch(updateSendBookingDoc(data));

    if (data.status === "success") {
      if (data.dataEdit !== undefined) {
        const addDoc = await editDocumentConfirmToDatabase(data.dataEdit);

        dispatch(setLoadingBooking(false));
        return data;
      } else {
        const addDoc = await addDocumentConfirmToDatabase(data.data);

        dispatch(setLoadingBooking(false));
        return data;
      }
    }
  } catch (error) {
    console.error(error);
    dispatch(setLoadingBooking(false));
  }
};

export const { updateStatusBookingRent } = BookingSlice.actions;
export const editStatusBookingRentDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingBooking(true));
    const data = await editStatusBookingRent(value);
    dispatch(updateStatusBookingRent(data));
    dispatch(setLoadingBooking(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingBooking(false));
  }
};

export const { updateDocumentAgreement } = BookingSlice.actions;
export const addDocumentAgreementDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingBooking(true));
    const data = await addBookingRentalAgreement(value);
    dispatch(updateDocumentAgreement(data));
    dispatch(setLoadingBooking(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingBooking(false));
  }
};

export const { updateResultsDocumentAgreement } = BookingSlice.actions;
export const getDocumentAgreementDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingBooking(true));
    const data = await getBookingRentalAgreement(value);
    dispatch(updateResultsDocumentAgreement(data));
    dispatch(setLoadingBooking(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingBooking(false));
  }
};

export const { updateGetDocumentConfirm } = BookingSlice.actions;
export const getBookingRentConfirmDetail = (value) => async (dispatch) => {
  await getBookingRentalConfirm(value).then(async (data) => {
    await dispatch(updateGetDocumentConfirm(data));
  });
};

export const { updateAddDocumentRelates } = BookingSlice.actions;
export const AddDocumentRelatesDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingBooking(true));
    const data = await addBookingRentalRelates(value);
    dispatch(updateAddDocumentRelates(data));
    dispatch(setLoadingBooking(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingBooking(false));
  }
};

export const { updateGetDocumentRelates } = BookingSlice.actions;
export const getBookingRentRelatesDetail = (value) => async (dispatch) => {
  await getBookingRentalRelates(value).then(async (data) => {
    await dispatch(updateGetDocumentRelates(data));
  });
};

export const { updateDeleteDocumentAgreement } = BookingSlice.actions;
export const deleteDocumentAgreementDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingBooking(true));
    const data = await deleteDocumentAgreementRent(value);
    dispatch(updateDeleteDocumentAgreement(data));
    dispatch(setLoadingBooking(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingBooking(false));
  }
};

export const { updateDeleteDocumentRelates } = BookingSlice.actions;
export const deleteDocumentRelatesDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingBooking(true));
    const data = await deleteDocumentRelatesRent(value);
    dispatch(updateDeleteDocumentRelates(data));
    dispatch(setLoadingBooking(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingBooking(false));
  }
};

export const { updateEditExtendStay } = BookingSlice.actions;
export const editExtendStayDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingBooking(true));
    const data = await editExtendStayRent(value);
    dispatch(updateEditExtendStay(data));
    dispatch(setLoadingBooking(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingBooking(false));
  }
};

export const { updateEditRemarkCancelToBooking } = BookingSlice.actions;
export const editRemarkCancelToBookingDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingBooking(true));
    const data = await editRemarkCancelToBooking(value);
    dispatch(updateEditRemarkCancelToBooking(data));
    dispatch(setLoadingBooking(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingBooking(false));
  }
};

export const { updateLawyerForRental } = BookingSlice.actions;
export const sendMailLawyerForRentalDetail = (value) => async (dispatch) => {
  try {
    const data = await sendEmailLawyerForRental(value);
    dispatch(updateLawyerForRental(data));
    return data;
  } catch (error) {
    console.error(error);
  }
};

// Sales
export const { updateAddSale } = BookingSlice.actions;
export const addSaleDetail = (value) => async (dispatch) => {
  try {
    const data = await addSales(value);
    dispatch(updateAddSale(data));
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateAddSaleAgreement } = BookingSlice.actions;
export const addSaleAgreementDetail = (value) => async (dispatch) => {
  try {
    const data = await addSalesAgreement(value);
    dispatch(updateAddSaleAgreement(data));
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateAddSaleRelates } = BookingSlice.actions;
export const addSaleRelatesDetail = (value) => async (dispatch) => {
  try {
    const data = await addSalesRelates(value);
    dispatch(updateAddSaleRelates(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateSale } = BookingSlice.actions;
export const getSalesDetail = (value) => async (dispatch) => {
  await getSales(value).then(async (data) => {
    await dispatch(updateSale(data));
  });
};

export const { updateSaleAgreement } = BookingSlice.actions;
export const getSalesAgreementDetail = (value) => async (dispatch) => {
  await getSalesAgreement(value).then(async (data) => {
    await dispatch(updateSaleAgreement(data));
  });
};

export const { updateSaleRelates } = BookingSlice.actions;
export const getSalesRelatesDetail = (value) => async (dispatch) => {
  await getSalesRelates(value).then(async (data) => {
    await dispatch(updateSaleRelates(data));
  });
};

export const { updateEditSale } = BookingSlice.actions;
export const editSaleDetail = (value) => async (dispatch) => {
  try {
    const data = await editSales(value);
    dispatch(updateEditSale(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateRemarkSale } = BookingSlice.actions;
export const getRemarkSalesDetail = (value) => async (dispatch) => {
  await getRemarkSales(value).then(async (data) => {
    await dispatch(updateRemarkSale(data));
  });
};

export const { updateAddRemarkSale } = BookingSlice.actions;
export const AddRemarkSaleDetail = (value) => async (dispatch) => {
  try {
    const data = await addRemarkSales(value);
    dispatch(updateAddRemarkSale(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateSendMailSale } = BookingSlice.actions;
export const sendSaleConfirmDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingBooking(true));
    const data = await sendEmailSale(value);
    dispatch(updateSendMailSale(data));

    if (data.status === "success") {
      const addDoc = await addDocConfirmSale(data.database);

      dispatch(setLoadingBooking(false));
      return data;
    }
  } catch (error) {
    console.error(error);
    dispatch(setLoadingBooking(false));
  }
};

export const { updateGetDocumentConfirmSale } = BookingSlice.actions;
export const getDocumentConfirmSaleDetail = (value) => async (dispatch) => {
  await getDocConfirmSales(value).then(async (data) => {
    await dispatch(updateGetDocumentConfirmSale(data));
  });
};

export const { updateAddPaymentTerm } = BookingSlice.actions;
export const AddPaymentTermDetail = (value) => async (dispatch) => {
  try {
    const data = await addPaymentTerm(value);
    dispatch(updateAddPaymentTerm(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateGetPaymentTerm } = BookingSlice.actions;
export const getPaymentTermDetail = (value) => async (dispatch) => {
  await getPaymentTerm(value).then(async (data) => {
    await dispatch(updateGetPaymentTerm(data));
  });
};

export const { updateEditPaymentTerm } = BookingSlice.actions;
export const EditPaymentTermDetail = (value) => async (dispatch) => {
  try {
    const data = await editPaymentTerm(value);
    dispatch(updateEditPaymentTerm(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateDeletePaymentTerm } = BookingSlice.actions;
export const deletePaymentTermDetail = (value) => async (dispatch) => {
  try {
    const data = await deletePaymentTerm(value);
    dispatch(updateDeletePaymentTerm(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateLawyerForSelling } = BookingSlice.actions;
export const sendMailLawyerForSellingDetail = (value) => async (dispatch) => {
  try {
    const data = await sendEmailLawyerForSelling(value);
    dispatch(updateLawyerForSelling(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateDeleteAgreementSale } = BookingSlice.actions;
export const deleteAgreementSaleDetail = (value) => async (dispatch) => {
  try {
    const data = await deleteAgreementSale(value);
    dispatch(updateDeleteAgreementSale(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateDeleteRelateSale } = BookingSlice.actions;
export const deleteRelateSaleDetail = (value) => async (dispatch) => {
  try {
    const data = await deleteRelateSale(value);
    dispatch(updateDeleteRelateSale(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateDeleteSellingDraft } = BookingSlice.actions;
export const deleteSellingDraftDetail = (value) => async (dispatch) => {
  try {
    const data = await deleteSellingDraft(value);
    dispatch(updateDeleteSellingDraft(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export default BookingSlice.reducer;
